import { render } from "./TeamCompactCell.vue?vue&type=template&id=508701c3&scoped=true"
import script from "./TeamCompactCell.vue?vue&type=script&lang=js"
export * from "./TeamCompactCell.vue?vue&type=script&lang=js"

import "./TeamCompactCell.vue?vue&type=style&index=0&id=508701c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508701c3"]])

export default __exports__